import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { BackstageTheme } from '@backstage/theme';
import { MenuIcon as MenuIconType } from '../types/menu';

// Material UI Icons - importar dinámicamente los más comunes
import HomeIcon from '@material-ui/icons/Home';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import CategoryIcon from '@material-ui/icons/Category';
import GroupIcon from '@material-ui/icons/Group';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import DescriptionIcon from '@material-ui/icons/Description';
import CloudIcon from '@material-ui/icons/Cloud';
import WebIcon from '@material-ui/icons/Web';
import StorageIcon from '@material-ui/icons/Storage';
import NotificationsIcon from '@material-ui/icons/Notifications';
import LinkIcon from '@material-ui/icons/Link';

// Mapeo de nombres de iconos Material UI
const materialIconMap: Record<string, React.ComponentType<any>> = {
  'Home': HomeIcon,
  'Search': SearchIcon,
  'Menu': MenuIcon,
  'Category': CategoryIcon,
  'Group': GroupIcon,
  'Extension': ExtensionIcon,
  'LibraryBooks': LibraryBooksIcon,
  'AddCircleOutline': AddCircleOutlineIcon,
  'Settings': SettingsIcon,
  'People': PeopleIcon,
  'Store': StoreIcon,
  'Description': DescriptionIcon,
  'Cloud': CloudIcon,
  'Web': WebIcon,
  'Storage': StorageIcon,
  'Notifications': NotificationsIcon,
  'Link': LinkIcon,
};

export const useIconResolver = () => {
  const theme = useTheme<BackstageTheme>();
  
  const resolveIcon = (iconConfig: MenuIconType): React.ReactNode => {
    switch (iconConfig.type) {
      case 'material':
        if (iconConfig.name && materialIconMap[iconConfig.name]) {
          const IconComponent = materialIconMap[iconConfig.name];
          return <IconComponent style={{ color: theme.palette.text.primary }} />;
        }
        return <HomeIcon style={{ color: theme.palette.text.primary }} />; // Fallback
      
      case 'svg':
        if (iconConfig.path) {
          // Para SVGs, podrías cargar dinámicamente o usar un componente wrapper
          return (
            <img 
              src={iconConfig.path} 
              alt="icon" 
              style={{ width: 24, height: 24 }}
            />
          );
        }
        return <HomeIcon style={{ color: theme.palette.text.primary }} />; // Fallback
      
      case 'component':
        if (iconConfig.component) {
          const IconComponent = iconConfig.component;
          // Para iconos de componente en el menú, usar el color del tema para consistencia
          return <IconComponent width={24} height={24} color={theme.palette.text.primary} />;
        }
        return <HomeIcon style={{ color: theme.palette.text.primary }} />; // Fallback
      
      default:
        return <HomeIcon style={{ color: theme.palette.text.primary }} />; // Fallback
    }
  };

  return { resolveIcon };
};
